type JanelaComCrisp = Window & {
  $crisp?: { is?: (estado: string) => boolean }
}

export function observarVisibilidadeDoCrisp (aoAlterar: (visivel: boolean) => void): () => void {
  let visibilidadeAnterior: boolean | undefined
  const atualizar = () => {
    const api = (window as JanelaComCrisp).$crisp
    const visivel = typeof api?.is === 'function' && api.is('chat:visible')
    if (visivel === visibilidadeAnterior) return
    visibilidadeAnterior = visivel
    aoAlterar(visivel)
  }

  // O SDK pode carregar depois da aplicação e ocultar o widget por suas
  // próprias regras. As mudanças no DOM permitem consultar seu estado real.
  const observador = new MutationObserver(atualizar)
  observador.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'style', 'hidden']
  })
  window.addEventListener('resize', atualizar)
  atualizar()

  return () => {
    observador.disconnect()
    window.removeEventListener('resize', atualizar)
  }
}
